import { useEffect, useState } from "react";
import {
  Svg,
  Circle,
  Pos,
  Lab,
  Outer,
  Text1,
  Text2,
  CircleGroup,
  LabContainer,
} from "./Overview.label.style";

import { useLocation } from "react-router-dom";
import { useGet } from "state/jotai";
import { active_project } from "state/store.global";
import { useClick } from "./Overview.label.click";
import { _project } from "state/store.projects";
import { useBreak } from "hooks/useBreak";
import { _bootstrap } from "state/store.bootstrap";

export const Label = ({
  c,
  sc,
  d,
  l,
  rmode,
  r,
  labelsInfo,
  line,
  angle,
  mobileLabelAxis,
  hoveredId,
}) => {
  const isMobile = useBreak("md_dn");

  const { pin, pid } = useGet(active_project);

  const unitStatus = useGet(_project)?.unitStatuses?.[pin]?.[pid] ?? [];
  const availableTranslation = unitStatus?.find((u) => u.ID === 10)?.Name ?? "";

  const projectUnitsStatus = useGet(_bootstrap)?.projects ?? [];
  const options = useGet(_project)?.filteroptions ?? {};
  const PID = labelsInfo?.PID;
  const PIN = labelsInfo?.PIN;

  const allUnits = useGet(_project)?.units ?? {};

  const totalUnits =
    allUnits?.[pin]?.[pid]?.Units?.reduce(
      (ac, val) => ac + (val?.Data?.ProjectID?.Value === PID ? 1 : 0),
      0
    ) ?? 0;

  // const roomSize =
  //   options?.[PIN]?.[PID]?.find(
  //     (p) => p?.Label === "Størrelse" || p?.Label === "Size"
  //   ) ?? "";

  // const noOfRooms =
  //   options?.[PIN]?.[PID]?.find(
  //     (p) => p?.Label === "Værelser" || p?.Label === "Rooms"
  //   ) ?? "";

  const hardcodedMoveInDate =
    allUnits?.[PIN]?.[PID]?.Units?.[0]?.Data?.Indflytningsdatoproperty
      ?.UnformattedValue;

  const here = useLocation().pathname.split("/");
  const buttonsLabel = useGet(_project)?.buttonsLabel?.[pin]?.[pid] ?? [];

  const isOverview = here[here.length - 1] === "isometry";

  const [notHovered, setNotHovered] = useState(true);
  const click = useClick();

  const [roomSize, setRoomSize] = useState({ min: null, max: null });
  const [area, setArea] = useState({ min: null, max: null });

  const s = 0.6 / sc === Infinity ? 10 : 0.6 / sc;
  const cx = r?.[0];
  const cy = r?.[1];
  const dl = { d, l, s, notHovered };

  useEffect(() => {
    if (!allUnits || !PID) return;

    let allRooms = [];
    let allAreas = [];

    Object.values(allUnits).forEach((unitGroup) => {
      const units = unitGroup?.[PID]?.Units || [];

      units.forEach(({ Data }) => {
        const rooms = parseFloat(Data?.VaerelserAntal?.Value);
        const unitArea = parseFloat(Data?.Areal?.Value);

        if (!isNaN(rooms)) allRooms.push(rooms);
        if (!isNaN(unitArea)) allAreas.push(unitArea);
      });
    });

    if (allRooms.length) {
      setRoomSize({
        min: Math.min(...allRooms),
        max: Math.max(...allRooms),
      });
    }

    if (allAreas.length) {
      setArea({
        min: Math.min(...allAreas),
        max: Math.max(...allAreas),
      });
    }
  }, [allUnits, PID]);

  useEffect(() => {
    setNotHovered(hoveredId !== labelsInfo?.URLSafe);
  }, [hoveredId, labelsInfo?.URLSafe]);
  
  const hasValue = (v) =>
    v !== null &&
    v !== undefined &&
    v !== "" &&
    !(typeof v === "number" && isNaN(v));

  const hasRange = (min, max) =>
    hasValue(min) && hasValue(max) && min !== Infinity && max !== -Infinity;
  if (isOverview && !rmode) {
    return (
      <Pos
        c={c}
        style={{
          position: "absolute",
          transform: "scale(1.6)",
          pointerEvents: "auto",
          zIndex: hoveredId === labelsInfo?.URLSafe ? 10 : 5,
        }}
      >
        <Svg viewBox="0 0 100 100">
          <CircleGroup transform={`translate(${cx} ${cy})`}>
            <Circle cx={0} cy={0} r={15} clr={clr} />
            <Circle cx={0} cy={0} r={25} fillOpacity="0.5" clr={clr} />
            <Circle cx={0} cy={0} r={35} fillOpacity="0.3" clr={clr} />
          </CircleGroup>
        </Svg>

        {hoveredId === labelsInfo?.URLSafe ? (
          /* 🔵 Hovered – full label */
          <Outer
            {...dl}
            xAxis={isMobile ? mobileLabelAxis?.[0] : ""}
            yAxis={isMobile ? mobileLabelAxis?.[1] : ""}
          >
            <LabContainer
              {...dl}
              clr={clr}
              onClick={!isMobile ? () => click(labelsInfo) : null}
            >
              <Text2
                style={{ borderBottom: "2px solid #fff", padding: "8px 16px" }}
              >
                {
                  buttonsLabel?.find(
                    (btn) => btn.UILabelProperty === "SeeAvailableUnits"
                  )?.Label
                }
              </Text2>

              <Lab clr={clr}>
                <Text1 s={s}>{labelsInfo?.Presentation}</Text1>

                {hasValue(totalUnits) && totalUnits > 0 && (
                  <Text2>
                    {totalUnits}{" "}
                    {totalUnits > 1
                      ? buttonsLabel
                          ?.find((btn) => btn.UILabelProperty === "boliger")
                          ?.Label?.toLowerCase()
                      : buttonsLabel
                          ?.find((btn) => btn.UILabelProperty === "bolig")
                          ?.Label?.toLowerCase()}
                  </Text2>
                )}

                <Text2>
                  {labelsInfo?.available_Units}{" "}
                  {labelsInfo?.available_Units > 1
                    ? buttonsLabel
                        ?.find((btn) => btn.UILabelProperty === "Ledige")
                        ?.Label?.toLowerCase()
                    : availableTranslation?.toLowerCase()}
                </Text2>

                {/* <Text2>{`${roomSize?.MinValue} - ${roomSize?.MaxValue} ${roomSize?.Postfix}`}</Text2>

                <Text2>
                  {`${noOfRooms?.MinValue} - ${noOfRooms?.MaxValue}`}{" "}
                  {noOfRooms?.MaxValue > 1
                    ? buttonsLabel?.find(
                        (btn) => btn.UILabelProperty === "værelser"
                      )?.Label
                    : buttonsLabel?.find(
                        (btn) => btn.UILabelProperty === "værelse"
                      )?.Label}
                </Text2> */}
                {hasRange(area.min, area.max) && (
                  <Text2 className="paragraph2-regular">
                    {`${area.min} - ${area.max} m²`}
                  </Text2>
                )}
                {hasRange(roomSize.min, roomSize.max) && (
                  <Text2>
                    {roomSize.min} - {roomSize.max}{" "}
                    {roomSize.max > 1
                      ? buttonsLabel?.find(
                          (btn) => btn.UILabelProperty === "værelser"
                        )?.Label
                      : buttonsLabel?.find(
                          (btn) => btn.UILabelProperty === "værelse"
                        )?.Label}
                  </Text2>
                )}
                {hardcodedMoveInDate && (
                  <Text2>
                    {
                      buttonsLabel?.find(
                        (btn) => btn.UILabelProperty === "Indflytning"
                      )?.Label
                    }
                    : {hardcodedMoveInDate}
                  </Text2>
                )}
              </Lab>
            </LabContainer>
          </Outer>
        ) : (
          /* ⚪ Default label */
          <Outer
            {...dl}
            xAxis={isMobile ? mobileLabelAxis?.[0] : ""}
            yAxis={isMobile ? mobileLabelAxis?.[1] : ""}
          >
            <LabContainer
              {...dl}
              clr={clr}
              onClick={!isMobile ? () => click(labelsInfo) : null}
            >
              <Text2 style={{ padding: "8px 16px" }}>
                {
                  buttonsLabel?.find(
                    (btn) => btn.UILabelProperty === "SeeAvailableUnits"
                  )?.Label
                }
              </Text2>
            </LabContainer>
          </Outer>
        )}
      </Pos>
    );
  }

  return null;
};
